import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Instagram, Phone, Mail, MapPin, ArrowUpRight } from 'lucide-react';
import { MotorInksLogo } from './Brand';
import { TID } from '@/testIds';

const EXPLORE = [
  { label: 'Services',      hash: 'services' },
  { label: 'Wrapulator',    hash: 'wrapulator' },
  { label: 'Portfolio',     hash: 'portfolio' },
  { label: 'Membership',    hash: 'membership' },
  { label: 'FAQ',           hash: 'faq' },
];

const PARTNERS = [
  { label: 'How It Works',      to: '/how-it-works' },
  { label: 'Wholesale Rate Card', to: '/rates' },
  { label: 'Aftercare Plans',   to: '/aftercare' },
  { label: 'Apply as Partner',  to: '/partners' },
  { label: 'Book an Install',   to: '/schedule' },
  { label: 'Partner Sign In',   to: '/login' },
];

export default function Footer() {
  const { pathname } = useLocation();
  const onHome = pathname === '/';
  const hashTo = (id) => (onHome ? `#${id}` : `/#${id}`);

  return (
    <footer className="relative bg-black border-t mi-line-strong">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid md:grid-cols-5 gap-10 mb-12">
          <div className="md:col-span-2">
            <MotorInksLogo variant="primary" height={68} className="mb-3 drop-shadow-[0_2px_10px_rgba(230,57,70,0.25)]" />
            <div className="mi-eyebrow mt-1 text-white/50">B2B WHITE LABEL INSTALL CO. · EST 2010</div>
            <p className="mt-6 text-white/70 leading-relaxed max-w-md">
              B2B white-label wrap installation. Your brand on the invoice, our certified crew on the vehicle.
              Fifteen years running. Nationwide via Install Guild.
            </p>
            <div className="mt-6 flex gap-3">
              <a href="https://www.instagram.com/motorinks/" target="_blank" rel="noopener noreferrer"
                 className="w-10 h-10 border mi-line-strong grid place-items-center hover:border-[#E63946] hover:text-[#E63946] transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="https://www.tiktok.com/@motorinks" target="_blank" rel="noopener noreferrer"
                 className="px-3 h-10 border mi-line-strong grid place-items-center hover:border-[#E63946] hover:text-[#E63946] mi-eyebrow text-[10px] transition-colors">
                TIKTOK
              </a>
            </div>
          </div>

          <div>
            <div className="mi-eyebrow mb-4 text-white/50">// EXPLORE</div>
            <ul className="space-y-3 text-white/80" data-testid="footer-explore">
              {EXPLORE.map((l) => (
                <li key={l.hash}>
                  {onHome
                    ? <a href={hashTo(l.hash)} data-testid={`footer-link-${l.hash}`} className="hover:text-[#E63946]">{l.label}</a>
                    : <Link to={hashTo(l.hash)} data-testid={`footer-link-${l.hash}`} className="hover:text-[#E63946]">{l.label}</Link>}
                </li>
              ))}
              <li>
                <a href="https://www.installguild.pro" target="_blank" rel="noopener noreferrer"
                   data-testid="footer-link-install-guild"
                   className="inline-flex items-center gap-1 text-[#E63946] hover:opacity-80">
                  Install Guild <ArrowUpRight className="w-3 h-3" />
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="mi-eyebrow mb-4 text-white/50">// PARTNERS</div>
            <ul className="space-y-3 text-white/80" data-testid="footer-partners">
              {PARTNERS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={`footer-link${l.to.replace(/\//g, '-')}`} className="hover:text-[#E63946]">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="mi-eyebrow mb-4 text-white/50">// CONTACT</div>
            <ul className="space-y-3 text-white/80">
              <li>
                <a href="tel:8327912692" data-testid={TID.footerPhone} className="inline-flex items-center gap-2 hover:text-[#E63946]">
                  <Phone className="w-4 h-4" /> 832.791.2692
                </a>
              </li>
              <li>
                <a href="mailto:sales@motorinks.com" data-testid={TID.footerEmail} className="inline-flex items-center gap-2 hover:text-[#E63946]">
                  <Mail className="w-4 h-4" /> sales@motorinks.com
                </a>
              </li>
              <li className="inline-flex items-center gap-2 text-white/60">
                <MapPin className="w-4 h-4" /> Houston · TX · USA
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t mi-line pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="mi-eyebrow text-white/40 text-[10px]">
            © {new Date().getFullYear()} MOTOR iNKS LLC · ALL RIGHTS RESERVED
          </div>
          <div className="mi-eyebrow text-white/40 text-[10px]">
            3M PREFERRED · AVERY CERTIFIED · ORAFOL AUTHORIZED
          </div>
        </div>
      </div>
    </footer>
  );
}
